<template>
	<card :key="forceUpdate">
		<div slot="header">
			
			<div class="row align-items-center">
				<div class="col-12 col-md-8">
					<h6>Rapporto lavorativo</h6>
				</div>
				<div class="col-12 col-md-4 text-center text-md-right">
					<base-button
						type="primary"
						@click="addDay()">
              			<i class="tim-icons icon-simple-add"></i>
						Aggiungi giorno
					</base-button>
				</div>
			</div>
		</div>
		<div class="table-days"
			:class="{
				'final-phase-layout' : model.phase === 'final'
			}">
			<div class="row row-days no-gutters" v-if="model.workedDetails">
				<div class="col col-worked-days col-label">
					<div class="field">Data</div>
					<div class="field">Ore lavorative</div>
					<div class="field">Ore straordinarie/festive lavorate</div>
					<div class="field">Ore viaggio</div>
					<div class="field">Diaria</div>
					<div class="field">Pernottamento</div>
					<div class="field">Km percorsi</div>
				</div>
				<div
					class="col col-worked-days"
					v-for="(day, $index) in model.workedDetails.days" :key="$index">
					<div class="field">
						<div class="form-group">
							<el-date-picker
								:picker-options="{
									firstDayOfWeek : 1
								}"
								format="dd/MM/yyyy"
								v-model="day.day"
								type="date"
								class="form-control-lg"
								size="large"
								placeholder="giorno" />
						</div>
					</div>
					<div class="field">
						<base-input
							v-model="day.workedHours"
							:name="`${$index}workedhours`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Ore lavorate" />
					</div>
					<div class="field">
						<base-input
							v-model="day.holidayWorkedHours"
							:name="`${$index}holidayWorkedHours`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Ore straordinarie/festive lavorate " />
					</div>
					<div class="field">
						<base-input
							v-model="day.tripHours"
							:name="`${$index}triphours`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Ore di viaggio" />
					</div>
					<div class="field">
						<base-input
							v-model="day.diem"
							:name="`${$index}diem`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Diaria" />
					</div>
					<div class="field">
						<base-input
							v-model="day.overNight"
							:name="`${$index}overNight`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Pernottamento" />
					</div>
					<div class="field">
						<base-input
							v-model="day.totalKmTrip"
							:name="`${$index}kmTrip`"
							type="number"
							input-size="form-control-lg"
							step="0.01"
							placeholder="Km viaggio" />
					</div>
					<div class="field bg-white d-flex">
						<base-button
							type="link"
							@click="changePosition($index,-1)"
							:disabled="$index === 0"
							class="m-auto d-block px-2 text-info"
							>
							<i class="tim-icons icon-minimal-left"></i>
						</base-button>		
						<base-button
							type="danger"
							@click="deleteDay($index)"
							class="m-auto d-block px-2"
							size="lg"
							>
							<i class="tim-icons icon-trash-simple"></i>
						</base-button>
						<base-button
							type="link"
							:disabled="$index === model.workedDetails.days.length -1 "
							@click="changePosition($index,1)"
							class="m-auto d-block px-2 text-info"
							>
							<i class="tim-icons icon-minimal-right"></i>
						</base-button>		
					</div>
				</div>
				<template v-if="model.phase === 'final' && model.workedDetails && model.workedDetails.detailsSingleAmount" >
					<div class="col col-worked-days col-total">
						<div class="field"><h6 class="mt-3 head">
							<span>TOTALI</span>
						 	|
						 	<span>Costo unitario</span> | 
						 	<span>TOTALE (€)</span>
						 </h6></div>
						<div class="field">

							<div class="addon-left">
								{{calculateTotalItems('workedHours')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.workedHours"
								name="AmountSingleworkedhours"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Ore lavorate" />
							<div class="addon-right">
								{{calculateTotal('workedHours')}}
								<span class="valuta">€</span>
							</div>
							
						</div>
						<div class="field">
							<div class="addon-left">
								{{calculateTotalItems('holidayWorkedHours')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.holidayWorkedHours"
								name="AmountSingleholidayWorkedHours"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Ore straordinarie/festive" />
							<div class="addon-right">
								{{calculateTotal('holidayWorkedHours')}}
								<span class="valuta">€</span>
							</div>
						</div>
						<div class="field">
							<div class="addon-left">
								{{calculateTotalItems('tripHours')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.tripHours"
								name="AmountSingletriphours"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Ore di viaggio" />
							<div class="addon-right">
								{{calculateTotal('tripHours')}}
								<span class="valuta">€</span>
							</div>
						</div>
						<div class="field">
							<div class="addon-left">
								{{calculateTotalItems('diem')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.diem"
								name="AmountSinglediem"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Diaria" />
							<div class="addon-right">
								{{calculateTotal('diem')}}
								<span class="valuta">€</span>
							</div>
						</div>
						<div class="field">
							<div class="addon-left">
								{{calculateTotalItems('overNight')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.overNight"
								name="AmountSingleoverNight"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Pernottamento" />
							<div class="addon-right">
								{{calculateTotal('overNight')}}
								<span class="valuta">€</span>
							</div>
						</div>
						<div class="field">
							<div class="addon-left">
								{{calculateTotalItems('totalKmTrip')}}
							</div>
							<base-input
								v-model="model.workedDetails.detailsSingleAmount.totalKmTrip"
								name="AmountSinglekmTrip"
								type="number"
								input-size="form-control-lg"
								step="0.01"
								placeholder="Km viaggio" />
							<div class="addon-right">
								{{calculateTotal('totalKmTrip')}}
								<span class="valuta">€</span>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</card>
</template>
<style lang="scss">
	
	.row-days{
		flex-wrap:nowrap;
	}
	.table-days{
		overflow: auto;
		position: relative;
		margin: 0 -15px;
		&.final-phase-layout{
			.row-days{
				// padding-right: 170px;
			}
		}
		.form-group{
			// border: 0;
			margin: 0 5px;
		}
	}
	.col-worked-days{
		width: 150px;
		min-width: 150px;
		max-width: 150px;
		.field{
			height: 50px;
			min-height: 50px;
			line-height: 50px;
			border-bottom: 1px solid #ccc;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			&:nth-child(2n){
				background: #eaeaea;
			}
			&.bg-white{
				border-bottom: 0;
			}
			&:hover{
				overflow: visible;
				span{
					background: white;
				}
			}
		}
		.form-group{
			margin-bottom: 0;
		}
	}
	.col-label{
		.field{
			padding-left: 15px;

		}
	}
	.col-total{
		width: 300px !important;
		min-width: 300px !important;
		max-width: 300px !important;
		background:white;
		position: sticky;
		border-left: 1px solid #999;
		box-shadow: 0 0 20px 0 rgba(0,0,0,0.5);
		right: 0;
		margin-left: auto;
		input{
			min-width: 90px;
			width: 90px;
			padding-left: 5px !important;
			padding-right: 5px !important;
		}		
		.form-group{
			border-right: 1px solid #ccc;
			padding-right: 10px;
			margin:0;
			&:after{
				display: none;
			}
		}
		.field{
			padding-left: 10px !important;
			display: flex;
			h6.head{
				span:first-child{
					min-width: 58px;
					display: inline-block;
				}
			}
			.addon-left{
				min-width: 60px;
				font-weight: bold;
			}
			.addon-right{
				text-align: right;
				max-height: 50px;
				padding-left: 7px;
				font-size: 1.5em;
				font-weight: bold;
				width: 100%;
				padding-right: 15px;
				.valuta{
					display: inline;
					font-size: 0.75em;
				}
			}
			input{
				width: 98px;
			}
		}
	}
</style>

<script>
	import moment from 'moment'
	import { DatePicker } from 'element-ui'
	import { debounce } from "debounce"

	export default {
		name: 'revision-worked-details',
		mounted() {
			if ( !this.model.workedDetails ){
				this.model.workedDetails= {}
			}
			if (!this.model.workedDetails.detailsSingleAmount){
				this.model.workedDetails.detailsSingleAmount = {}
			}
		},
		props: {
			model: Object,
		},
		components: {
			[DatePicker.name]: DatePicker
		},
		data() {
			return {
				forceUpdate: 0
			}
		},
		methods: {
			changePosition(i,howMuch){
				const destIndex = i + howMuch;
				this.model.workedDetails.days[i] = this.model.workedDetails.days.splice(destIndex, 1, this.model.workedDetails.days[i])[0];
				return this.model.workedDetails.days;
			},
			calculateTotalItems(key){
				let sum = 0;
				if (!this.model.workedDetails.days){
					return 0;
				}
				this.model.workedDetails.days.forEach(day => {
					sum = day[key] ? sum + parseFloat(day[key]) : sum;
				})
				const total = sum;
				return isNaN(total) ? (0) : total;
			},
			addDay() {
				if (!this.model.workedDetails.days){
					this.model.workedDetails.days = []
				}
				this.model.workedDetails.days.push({
					day: moment(new Date()).add('days',this.model.workedDetails.days.length).toDate()
				})
				this.forceUpdate++
			},
			calculateTotal(key){
				let sum = 0;
				if (!this.model.workedDetails.days){
					return 0;
				}
				this.model.workedDetails.days.forEach(day => {
					sum = day[key] ? sum + parseFloat(day[key]) : sum;
				})
				const total = parseFloat(this.model.workedDetails.detailsSingleAmount[key]) * sum;
				return isNaN(total) ? (0).toFixed(2) : total.toFixed(2)
			},
			deleteDay(i){
				this.model.workedDetails.days.splice(i,1)
			},
			// Funzione in disuso che aggiungeva un giorno in automatico.
			// checkInputDays:  debounce(function({target}){
			// 	const lastDay = this.model.workedDetails.days[this.model.workedDetails.days.length - 1]
			// 	// const lastDescription = this.model.productsUsed[this.model.productsUsed.length-1].description;
			// 	// const lastCode = this.model.productsUsed[this.model.productsUsed.length-1].description;
			// 	//Se qualcosa è valorizzao
			// 	if (lastDay !== undefined
			// 		&& ( lastDay.workedHours
			// 			|| lastDay.holidayWorkedHours
			// 			|| lastDay.tripHours
			// 			|| lastDay.diem
			// 			|| lastDay.overNight
			// 			|| lastDay.totalKmTrip
			// 		)){
			// 		this.addDay()
			// 	}
			// 	// // rimuovo gli ultimi
			// 	const vm = this;
			// 	// this.model.workedDetails.days = this.model.workedDetails.days.filter((day,i) => {
			// 	// 	return i === vm.model.workedDetails.days.length - 1 
			// 	// 		|| (day.workedHours
			// 	// 		|| day.holidayWorkedHours
			// 	// 		|| day.tripHours
			// 	// 		|| day.diem
			// 	// 		|| day.overNight
			// 	// 		|| day.totalKmTrip)
			// 	// })
			// 	this.forceUpdate++
			// },500),
		}
	}	
</script>
